import { render, staticRenderFns } from "./add-customer-popup.vue?vue&type=template&id=65c81594&"
import script from "./add-customer-popup.vue?vue&type=script&lang=ts&"
export * from "./add-customer-popup.vue?vue&type=script&lang=ts&"
import style0 from "./add-customer-popup.vue?vue&type=style&index=0&id=65c81594&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports